export class CampaignDatePresets {
  static readonly CURRENT_AND_UPCOMING = 'CURRENT_AND_UPCOMING' as const;
  static readonly PAST = 'PAST' as const;

  static readonly values = [
    CampaignDatePresets.CURRENT_AND_UPCOMING,
    CampaignDatePresets.PAST,
  ] as const;

  static readonly default = CampaignDatePresets.CURRENT_AND_UPCOMING;

  static parse(v: string | null): CampaignDatePreset {
    return this.values.find((preset) => preset === v) ?? this.default;
  }
}

export type CampaignDatePreset = (typeof CampaignDatePresets.values)[number];
